import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import { QueryClientProvider } from '@tanstack/react-query'
import { Toaster } from 'sonner'
import { AuthProvider } from '@/auth/auth-provider'
import { App } from './App'
import { queryClient } from '@/lib/query-client'
import { UnsavedChangesProvider } from '@/components/shared/unsaved-changes'
import './index.css'

// A data router supplies a single shared blocker for in-app links and browser Back.
const router = createBrowserRouter([{
  path: '*',
  element: <QueryClientProvider client={queryClient}>
    <AuthProvider>
      <UnsavedChangesProvider><App /><Toaster richColors position="top-right" /></UnsavedChangesProvider>
    </AuthProvider>
  </QueryClientProvider>,
}])

createRoot(document.getElementById('root')!).render(
  <StrictMode><RouterProvider router={router} /></StrictMode>,
)
